import angular from 'angular';
import sortComponent from './sortComponent';

angular.module('sh.sort', []).directive('shSort', sortComponent);
